// extracted by mini-css-extract-plugin
module.exports = {"container":"MixedBlock_container__5NUfA","containerIstextRight":"MixedBlock_containerIstextRight__lLOmk","media":"MixedBlock_media__HD8b4","text":"MixedBlock_text__Pkl0T"};